import { exportModule } from './module';
import { state } from './state';
import { subscribers } from './subscribers';

export * from './utils';

export const LocaleModule = exportModule({
  state,
  subscribers
});
